import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { ChangeStatus } from "../../../Components";
import Loader from "../../../Components/Loader";
import JobService from "../../../Services/JobService";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import { MdVisibility } from "react-icons/md";
import ReactPaginate from "react-paginate";


const FinanciallyClosedJobList = () => {
  const history = useHistory();

  const [jobItem, setJobItem] = useState([]);
  const [startDate, setStarDate] = useState();
  const [endDate, setEndData] = useState();
  const [searchField, setSearchField] = useState();
  const [loader, setLoader] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  const [addModal, setAddModal] = useState(false);
  const [jobtoken, setJobtoken] = useState("");


  useEffect(() => {
    getJobList();
  }, [searchField, startDate, endDate, currentPage]);


  const getJobList = () => {
    let param = { is_financially_open: false };
    param = {
      ...param,
      page: currentPage,
      limit: pagination.limit,
    };
    if (startDate) {
      param["start_date"] = getTimeStamp(startDate);
    }
    if (endDate) {
      param["end_date"] = getTimeStamp(endDate);
    }
    if (searchField) {
      param["search"] = searchField;
    }
    setLoader(true);
    JobService.getJobapi(param).then((result) => {
      if (result.status === true) {
        setJobItem(result.data);
        setPagination({ ...pagination, ...result.pagination });
        setLoader(false);
      } else {
        setLoader(false);
      }
    });
  };

  const getTimeStamp = (date) => {
    let SingleTimestamp = new Date(date);
    return SingleTimestamp.getTime();
  };

  const handleFinancialStatus = (val) => {
    setJobtoken(val?.job_token);
    setAddModal(true);
  };

  function resetHandler() {
    setStarDate("");
    setEndData("");
    setSearchField("");
  }

  const getSumValue = (array) => {
    let plusVolume = array
      .map((item) => item.booking.total_volume_CBM)
      .reduce((prev, cur) => prev + cur, 0);

    let plusWeight = array
      .map((item) => item.booking.total_weight_KG)
      .reduce((prev, cur) => prev + cur, 0);

    let plusPackage = array
      .map((item) => item.booking.no_of_pkgs)
      .reduce((prev, cur) => prev + cur, 0);

    return {
      totalvolume: plusVolume.toFixed(2),
      totalweight: plusWeight,
      totalpkg: plusPackage,
    };
  };

  const onModalSubmit = () => {
    let payload = {
      job_token: isModalOpen.job_token,
      status: isModalOpen.is_job_open === "OPEN" ? "CLOSE" : "OPEN",
      is_financially_open: false,
    };
    JobService.setJobOpenStatus(payload).then((result) => {
      setIsModalOpen(false);
      if (result.status) {
        toast.success(result.message);
        getJobList();
      } else {
        toast.error(result.message);
      }
    });
  };

  const handleSubmitStatus = () => {
    let payload = {
      status: false,
      job_token: jobtoken,
    };
    JobService.closeFinancialStatus(payload)
      .then((res) => {
        if (res.status === true) {
          setAddModal(false);
          toast.success(res.message);
          getJobList();
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const closeFinancially = async () => {
    let payload = {
      status: true,
      job_token: jobtoken,
    };

    await JobService.closeFinancialStatus(payload)
      .then((res) => {
        if (res.status === true) {
          toast.success(res.message);
          getJobList();
        } else {
          toast.error(res.message);
        }
        setIsModalOpen2(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex mb-3 justify-content-start align-items-end table_filter">
              <div className="col-2">
                <label>Search Token</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search.."
                  onChange={(e) => setSearchField(e.target.value)}
                  value={searchField}
                />
              </div>
              <div className="col-2">
                <label>Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setStarDate(e.target.value)}
                  value={startDate}
                />
              </div>
              <div className="col-2">
                <label>End Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setEndData(e.target.value)}
                  value={endDate}
                />
              </div>

              <div className="mx-2 col-4">
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  onClick={() => resetHandler()}
                >
                  Reset
                </button>
              </div>
              {/* <div >
            </div> */}
            </div>

            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th rowSpan="2">S no.</th>
                    <th rowSpan="2"> Job No.</th>
                    <th rowSpan="2"> Shipping Mode</th>
                    <th rowSpan="2">
                      Customer <br />
                      Name
                    </th>
                    <th rowSpan="2">Job Date</th>
                    <th rowSpan="2">Destination</th>
                    <th rowSpan="2">
                      Payment <br /> Status
                    </th>
                    <th rowSpan="2">
                      {" "}
                      Financial Status
                    </th>
                    <th rowSpan="2">
                      Job <br /> Status
                    </th>

                    <th rowSpan="2" className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {jobItem &&
                    jobItem.length > 0 &&
                    jobItem.map((val, key) => {
                      if (Array.isArray(val.quote_request_items)) {
                        var calculateVal = getSumValue(val.quote_request_items);
                      }
                      return (
                        <tr key={key}>
                          <td scope="row">{(pagination.page - 1) * pagination.limit + (key + 1)}</td>
                          <td>{val.job_token}</td>
                          <td>
                            <span className="badge rounded-pill font-size-12 pointer bg-success">
                              {(val && val.shipment_details.shipment_mode) ||
                                "NA"}
                            </span>
                          </td>

                          <td>{val.customer_details.name || "NA"}</td>
                          <td>{moment(val.created_at).format("DD-MM-YYYY")}</td>
                          <td>
                            {val.shipment_details.destination +
                              (val.shipment_details?.destination_country
                                ? " ," +
                                val.shipment_details.destination_country
                                : "")}
                          </td>
                          <td>
                            {" "}
                            <span className="badge rounded-pill font-size-12 pointer bg-success">
                              {(val.payment_information &&
                                val.payment_information.payment_status) ||
                                "NA"}
                            </span>{" "}
                          </td>
                          <td>
                            <span
                              className="badge rounded-pill font-size-12 pointer bg-success"
                              onClick={() => {
                                setIsModalOpen2(val);
                                setJobtoken(val?.job_token);
                              }}
                            >
                              {(val.is_financially_open ? 'OPEN' : "CLOSED")}
                            </span>{" "}
                          </td>
                          <td>
                            {" "}
                            <span
                              className="badge rounded-pill font-size-12 pointer bg-success"
                              onClick={() => {
                                setIsModalOpen(val);
                              }}
                            >
                              {val.is_job_open || "NA"}
                            </span>
                          </td>
                          <td>
                            <MdVisibility
                              className="pointer"
                              onClick={() =>
                                history.push(
                                  "/view-job-cart?id=" + val._id,
                                  val
                                )
                              }
                              color="#0323fe"
                              size="25px"
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              {jobItem && jobItem.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

              <Loader isShow={loader} />

              {jobItem &&
                jobItem.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={addModal}
        onHide={() => setAddModal(false)}
        animation={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Job Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <AddGallery setAddModal={setAddModal} getGalleryimg={getGalleryimg}/> */}
          <h6>Are you sure want to close Job</h6>
          {/* <AddGallery setAddModal={setAddModal} getGalleryimg={getGalleryimg} /> */}
        </Modal.Body>
        <hr className="mt-0" style={{ color: "rgba(0,0,0,.1)" }} />
        <Button
          type="submit"
          className="mt-2 mb-2 mx-auto d-block w-25"
          onClick={handleSubmitStatus}
        >
          {(loader && <Spinner animation="grow" size="sm" />) || "Save"}
        </Button>
      </Modal>

      {Boolean(isModalOpen) && (
        <ChangeStatus
          isOpen={Boolean(isModalOpen)}
          title="Change Job Status"
          message={`Are you sure want to ${isModalOpen.is_job_open === "OPEN" ? "Close" : "Open"
            }`}
          onSubmitEvent={() => onModalSubmit()}
          handleClose={() => setIsModalOpen(false)}
        />
      )}

      {Boolean(isModalOpen2) && (
        <ChangeStatus
          isOpen={Boolean(isModalOpen2)}
          title="Change Financial Status"
          message={`Are you sure want to financially ${isModalOpen.is_financially_open ? "Close" : "Open"
            } this job?`}
          onSubmitEvent={() => closeFinancially()}
          handleClose={() => setIsModalOpen2(false)}
        />
      )}
    </div>
  );
};

export default FinanciallyClosedJobList;

